<template>
  <action-dispatcher
    action="courses/searchLessons"
    :parameters="$route.query"
    class="view-search text-light py-5"
  >
    <form
      class="container py-4 d-flex justify-content-center"
      @submit.prevent="submit"
    >
      <div class="input-wrapper">
        <button class="bg-transparent border-0 p-0" type="submit">
          <i class="fas fa-search text-secondary"></i>
        </button>
        <input ref="input" v-model="text" type="text" />
      </div>
    </form>

    <div v-for="category in categories" :key="category.id" class="py-4">
      <div class="container">
        <h5>{{ category.name }}</h5>
      </div>

      <div class="position-relative">
        <div class="container">
          <swiper :navigation="true" :breakpoints="breakpoints">
            <template v-for="lesson in categoryLessons(category.id)">
              <swiper-slide v-if="!lesson.is_month" :key="lesson.id">
                <lesson-slide :lesson="lesson" />
              </swiper-slide>
            </template>
          </swiper>
        </div>
      </div>
    </div>
  </action-dispatcher>
</template>

<script>
import Swiper from "@/components/Swiper";
import SwiperSlide from "@/components/SwiperSlide";
import LessonSlide from "@/components/home/LessonSlide";
import { mapState } from "vuex";
import { breakpoints } from "@/functions/helpers";
import get from "lodash/get";

export default {
  components: {
    Swiper,
    SwiperSlide,
    LessonSlide
  },
  data() {
    return {
      breakpoints,
      text: this.$route.query.search
    };
  },
  computed: {
    ...mapState("courses", ["categories", "lessons"])
  },
  methods: {
    submit() {
      this.$router.push({
        query: {
          search: this.text
        }
      });
    },
    categoryLessons(categoryId) {
      return this.lessons.filter(
        lesson => get(lesson, "category_cache.id") === categoryId
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.view-search {
  .input-wrapper {
    border: 1px solid white;
    background: transparent;
    border-radius: 32px;
    padding: 8px 16px;
    max-width: 100%;
    min-width: 40%;
    width: 300px;
    display: flex;

    input {
      border: none;
      background: transparent;
      color: white;
      margin-left: 8px;
      flex: 1 1 100%;
    }
  }

  h5 {
    margin-bottom: 16px;
    font-size: 18px;
  }
}
</style>
